import React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import Modal from '../../../ui/Modal'
import ApplyPromotionForm from './ApplyPromotionForm'

import UIMessages from '../../../../utils/ui-messages'

import { IPromotion, IApplyPromotion } from '../../../../types'

interface IApplyPromotionsModalProps extends RouteComponentProps {
  orgId: string
  userId: string
  promotions: IPromotion[]
  getAllPromotions: (orgId: string) => Promise<void>
  applyPromotion: (promotion: IApplyPromotion) => Promise<void>
}

export default class ApplyPromotionsModal extends React.Component<IApplyPromotionsModalProps> {
  public componentDidMount() {
    this.props.getAllPromotions(this.props.orgId)
  }

  public render() {
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='med-modal'>
            <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>
              {UIMessages.common.addPromotion}
            </span>
            <div className='border-top mt1'>
              <div className='mb1'>
                <ApplyPromotionForm
                  onSubmit={this.applyPromotion}
                  promotions={this.props.promotions}
                  userId={this.props.userId}
                  onCancel={this.props.history.goBack}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  public applyPromotion = async (promotion: IApplyPromotion) => {
    await this.props.applyPromotion(promotion)
    await this.props.history.goBack()
  }
}



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/promotions/ApplyPromotionModal.tsx